import { render } from "./LeiturasAutomaticasPage.vue?vue&type=template&id=22a65377"
import script from "./LeiturasAutomaticasPage.vue?vue&type=script&lang=js"
export * from "./LeiturasAutomaticasPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__